export default __webpack_public_path__ + "static/media/57.e0611179.jpeg";